module.exports = __webpack_public_path__ + "dimer/static/img/DrZJ.0953d15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DrZJ.jpg
// module id = qCy1
// module chunks = 0